var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEncendidoSinPruebaDeAlcohol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#4414db;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-encendido-sin-prueba-de-alcohol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_15",
    "data-name": "38 copia 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,54.49V61H77.16v5.82H64.38a12.73,12.73,0,0,0,0,25.45H77.16v5.83H89.37v4.66H96V61.13h61.43V166.61H129.5v6.64h34.58V54.49Zm-25,31.17a6.09,6.09,0,0,1,0-12.17H77.16V85.66ZM83.8,91.49V67.67h5.57V91.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,70.1H104.29v37.62h43.86Zm-6.64,31H110.94V76.74h30.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.69,183.1a36.18,36.18,0,1,1,36.17-36.18A36.22,36.22,0,0,1,92.69,183.1Zm0-65.71a29.54,29.54,0,1,0,29.53,29.53A29.57,29.57,0,0,0,92.69,117.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.38,146.92l11.36-11.35a3.32,3.32,0,0,0-4.7-4.7L92.69,142.23,81.33,130.87a3.32,3.32,0,1,0-4.7,4.7L88,146.92,76.63,158.28a3.32,3.32,0,0,0,4.7,4.7l11.36-11.36L104,163a3.32,3.32,0,0,0,4.7-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEncendidoSinPruebaDeAlcohol);
export default __webpack_public_path__ + "static/media/ic-encendido-sin-prueba-de-alcohol.de5c1584252953269cb5e79bda093681.svg";
export { ForwardRef as ReactComponent };